import { 
    getModifiedDutyEmployees, 
    createModifiedDutyEmployee, 
    updateModifiedDutyEmployee 
} from "../api/modifiedDuty";
import { 
    ModifiedDutyEmployee, 
    CreateModifiedDutyEmployeeRequest, 
    UpdateModifiedDutyEmployeeRequest,
    ModifiedDutySaveResponse
} from '../interfaces/ModifiedDutyInterface';

export const grabModifiedDutyEmployees = async (): Promise<ModifiedDutyEmployee[]> => {
    const apiResults = await getModifiedDutyEmployees();
    console.log(apiResults);
    return apiResults;
};

export const addModifiedDutyEmployee = async (
    newModifiedDutyEmployee: CreateModifiedDutyEmployeeRequest
): Promise<ModifiedDutySaveResponse> => {
    const apiResults = await createModifiedDutyEmployee(newModifiedDutyEmployee);
    console.log(apiResults);
    return apiResults;
};

export const changeModifiedDutyEmployee = async (
    id: number,
    updatedModifiedDutyEmployee: UpdateModifiedDutyEmployeeRequest
): Promise<ModifiedDutySaveResponse> => {
    const apiResults = await updateModifiedDutyEmployee(id, updatedModifiedDutyEmployee);
    console.log(apiResults);
    return apiResults;
};

